import { render, staticRenderFns } from "./settle_goods.vue?vue&type=template&id=327ebe1c&scoped=true"
import script from "./settle_goods.vue?vue&type=script&lang=js"
export * from "./settle_goods.vue?vue&type=script&lang=js"
import style0 from "./settle_goods.vue?vue&type=style&index=0&id=327ebe1c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ebe1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327ebe1c')) {
      api.createRecord('327ebe1c', component.options)
    } else {
      api.reload('327ebe1c', component.options)
    }
    module.hot.accept("./settle_goods.vue?vue&type=template&id=327ebe1c&scoped=true", function () {
      api.rerender('327ebe1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/order_manage/form/components/settle_goods.vue"
export default component.exports